import fetch,{getBlob} from '../utils/fetch';


export function addWorkOrder(data) {
  return fetch({
    method:'POST',
    url:'/workOrder/addWorkOrder',
    data
  })
}

export function dealWorkOrder(params) {
  return fetch({
    method:'GET',
    url:'/workOrder/dealWorkOrder',
    params
  })
}


export function deleteWorkOrder(params) {
  return fetch({
    method:'GET',
    url:'/workOrder/deleteWorkOrder',
    params
  })
}


export function findWorkOrderDetail(params) {
  return fetch({
    method:'GET',
    url:'/workOrder/findWorkOrderDetail',
    params
  })
}

export function findWorkOrderList(data) {
  return fetch({
    method:'POST',
    url:'/workOrder/findWorkOrderList',
    data
  })
}

export function findWorkOrderTypeList(data) {
  return fetch({
    method:'POST',
    url:'/workOrder/findWorkOrderTypeList',
    data
  })
}


// 房间号模糊查询
export function fuzzyRoom(params) {
	return fetch({
		method: 'GET',
		url: 'projectBasics/fuzzyroom',
		params
	})
}
//根据房间号查合同
export function roomOwn(params) {
  return fetch({
    method:'GET',
    url:'/contract/roomOwn',
    params
  })
}

//获取管家
export function getProjectZos(params) {
  return fetch({
    method:'GET',
    url:'basics/getProjectZos',
    params
  })
}

// workOrder/exportWorkOrderList
export function exportWorkOrderList(data) {
  return getBlob({
    method:'POST',
    url:'workOrder/exportWorkOrderList',
    data
  })
}

